<template>
  <div id="vpsRefund">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ $t('menu.vpsRefund') }}</h2>
          <p></p>
        </div>
        <div class="meta_box">
          <p class="mb-6">{{ $t('promotion.vps.intro') }}</p>
          <p class="mb-6" v-html="$t('promotion.vps.intro2')"></p>
          <div v-if="isSaveChange">
            <p class="mb-5">{{ $t('promotion.vps.agreeVPS') }}</p>
            <el-button
              type="primary"
              data-testid="submitNewApplication"
              class="el-button blue_button"
              @click="createNewVPS()"
            >
              {{ $t('promotion.vps.submitNewApplication') }}
            </el-button>
            <div class="view_tnc">
              <i18n path="promotion.vps.tnc">
                <template v-slot:link>
                  <a :href="tncLink" target="_blank" data-testid="tnc">
                    {{ $t('promotion.vps.link') }}
                  </a>
                </template>
              </i18n>
            </div>
          </div>
          <div v-else>
            <el-checkbox v-model="isAgreeTnc" class="vps agree_tnc" data-testid="agreeTnc">
              <i18n path="promotion.vps.agreeTnc">
                <template v-slot:link>
                  <a :href="tncLink" target="_blank" data-testid="tnc" class="link_text">{{
                    $t('promotion.vps.tncLink')
                  }}</a>
                </template>
              </i18n>
              <div v-if="showCheckboxError" class="text-red pt-1">{{ $t('promotion.vps.tncValidation') }}</div>
            </el-checkbox>
            <el-button type="primary" data-testid="saveChange" class="el-button blue_button" @click="saveChange">{{
              $t('promotion.vps.saveChange')
            }}</el-button>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeTab" class="campaign_custom_tab">
        <el-tab-pane v-for="tab in dynamicTabs" :key="tab.name" :label="tab.label" :name="tab.name">
          <component :is="tab.component" v-bind="tab.props" />
        </el-tab-pane>
      </el-tabs>
      <VpsDialog :dialogVisible.sync="dialogVisible" :tncLink="tncLink" @updateHistoryTable="getData"></VpsDialog>
    </div>
  </div>
</template>

<script>
import ClaimHistory from '@/components/vpsRefund/VpsClaimHistory';
import VpsDialog from '@/components/vpsRefund/VpsDialog';
import VpsFaq from '@/components/vpsRefund/Faq';
import { apiVpsHistory, apiVpsGetSaveChange, apiVpsSetSaveChange } from '@/resource';
import { countryCodeEnum } from '@/constants/country';

export default {
  name: 'vpsRefund',
  components: { ClaimHistory, VpsFaq, VpsDialog },
  data() {
    return {
      activeTab: 'claimHistory',
      tableData: [],
      dialogVisible: false,
      isAgreeTnc: false,
      showCheckboxError: false,
      isSaveChange: false,

      isRTL: false
    };
  },
  computed: {
    tncLink() {
      const isGCNCountry = [countryCodeEnum.CHINA, countryCodeEnum.HONG_KONG, countryCodeEnum.MACAO].includes(
        parseInt(this.$store.state.common.countryCode)
      );

      if (isGCNCountry) {
        switch (this.$store.state.common.lang) {
          case 'zh_TW':
            return 'https://www.vtmarketsglobal.com/vps-refund-terms-and-conditions.html';
          default:
            return 'https://www.vtmarketsglobalcn.com/vps-refund-terms-and-conditions.html';
        }
      } else {
        return 'https://www.vtmarkets.net/vps-refund/';
      }
    },
    dynamicTabs() {
      const tabs = [
        {
          label: this.$t('promotion.vps.claimHistory'),
          name: 'claimHistory',
          component: 'ClaimHistory',
          props: {
            tableData: this.tableData
          }
        },
        {
          label: this.$t('promotion.vps.faq.title'),
          name: 'vpsFaq',
          component: 'VpsFaq',
          props: {}
        }
      ];
      return this.isRTL ? tabs.slice().reverse() : tabs;
    }
  },
  methods: {
    createNewVPS() {
      this.dialogVisible = true;
    },
    async getData() {
      const historyData = await apiVpsHistory();
      if (Array.isArray(historyData.data.data)) {
        this.tableData = historyData.data.data;
      }
      const vpsGetSave = await apiVpsGetSaveChange();
      if (vpsGetSave.data.code === 0) this.isSaveChange = vpsGetSave.data.data;
    },
    saveChange() {
      if (!this.isAgreeTnc) {
        this.showCheckboxError = true;
      } else {
        this.showCheckboxError = false;
        apiVpsSetSaveChange();
        this.isSaveChange = true;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isRTL = document.body.dir === 'rtl';
    });
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/promotion/tabs.scss';
@import '@/assets/css/pages/vpsRefund.scss';
</style>
